(() => {
  const moveCiwiToFooter = () => {
    const slot = document.getElementById('rehair-ciwi-footer-slot');
    const container = document.getElementById('ciwi-container');
    if (!slot || !container || slot.contains(container)) return;

    const mainBox = container.querySelector('#main-box');
    const displayText = container.querySelector('#display-text');
    if (!mainBox || !displayText?.textContent.trim() || getComputedStyle(mainBox).display === 'none') return;

    const host = container.closest('ciwiswitcher-form') || container.closest('#localization_form') || container;
    slot.appendChild(host);

    container.style.setProperty('position', 'relative', 'important');
    container.style.setProperty('inset', 'auto', 'important');

    const selectorBox = container.querySelector('#selector-box');
    if (selectorBox) {
      selectorBox.style.setProperty('top', 'auto', 'important');
      selectorBox.style.setProperty('right', 'auto', 'important');
      selectorBox.style.setProperty('bottom', 'calc(100% + 6px)', 'important');
      selectorBox.style.setProperty('left', '0', 'important');
    }
  };

  // Coalesce third-party DOM churn into at most one layout check per frame.
  let frame = 0;
  const scheduleMove = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      moveCiwiToFooter();
    });
  };
  const start = () => {
    moveCiwiToFooter();
    new MutationObserver(scheduleMove).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', scheduleMove);
})();
